export interface LNavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: LNavigationRoute[]
}

import { recruitmentTrainingNavigationRoute } from './recruitmentTrainingNavigation'

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard-v2',
      displayName: 'Support Console',
      meta: {
        icon: 'support_agent',
        allowedRoles: ['support_agent'],
      },
      children: [
        {
          name: 'analytics',
          displayName: 'Support Analytics',
          meta: { icon: 'analytics', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'tickets',
      displayName: 'Ticket Management',
      meta: { icon: 'assignment', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'tickets',
          displayName: 'All Tickets',
          meta: { icon: 'assignment', allowedRoles: ['support_agent'] },
        },
        {
          name: 'ticket-management',
          displayName: 'Ticket Management',
          meta: { icon: 'manage_accounts', allowedRoles: ['support_agent'] },
        },
        {
          name: 'issues',
          displayName: 'Issues',
          meta: { icon: 'report_problem', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'driver-support',
      displayName: 'Driver Support Chat',
      meta: { icon: 'forum', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'driver-support',
          displayName: 'Support Desk',
          meta: { icon: 'forum', allowedRoles: ['support_agent'] },
        },
        {
          name: 'outbound-messages',
          displayName: 'Outbound Messages',
          meta: { icon: 'chat', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'drivers',
      displayName: 'Driver Support',
      meta: { icon: 'moped', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'drivers',
          displayName: 'Driver Issues',
          meta: { icon: 'moped', allowedRoles: ['support_agent'] },
        },
        {
          name: 'our-drivers',
          displayName: 'Our Drivers',
          meta: { icon: 'person', allowedRoles: ['support_agent'] },
        },
        {
          name: 'trips',
          displayName: 'Trip Support',
          meta: { icon: 'route', allowedRoles: ['support_agent'] },
        },
      ],
    },
    recruitmentTrainingNavigationRoute,
    {
      name: 'vehicles',
      displayName: 'Charging Support',
      meta: { icon: 'ev_station', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'vehicles',
          displayName: 'Vehicle Issues',
          meta: { icon: 'commute', allowedRoles: ['support_agent'] },
        },
        {
          name: 'our-vehicles',
          displayName: 'Our Vehicles',
          meta: { icon: 'directions_car', allowedRoles: ['support_agent'] },
        },
        {
          name: 'bikes',
          displayName: 'Bikes',
          meta: { icon: 'two_wheeler', allowedRoles: ['support_agent'] },
        },
        {
          name: 'maintenance',
          displayName: 'Charging Issues',
          meta: { icon: 'ev_station', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'messages',
      displayName: 'Customer Chat',
      meta: { icon: 'message', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'messages',
          displayName: 'Inbound Chat',
          meta: { icon: 'message', allowedRoles: ['support_agent'] },
        },
        {
          name: 'alarms',
          displayName: 'Alerts',
          meta: { icon: 'notifications', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'reports',
      displayName: 'Support Reports',
      meta: { icon: 'assessment', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'reports',
          displayName: 'Resolution Reports',
          meta: { icon: 'assessment', allowedRoles: ['support_agent'] },
        },
        {
          name: 'analytics',
          displayName: 'Performance Analytics',
          meta: { icon: 'analytics', allowedRoles: ['support_agent'] },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['support_agent'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['support_agent'],
          },
        },
        {
          name: 'vehicle-activity-reports',
          displayName: 'Vehicle Activity',
          meta: {
            icon: 'sensors',
            allowedRoles: ['support_agent'],
          },
        },
        {
          name: 'fleet-telemetry-reports',
          displayName: 'Fleet Telemetry',
          meta: {
            icon: 'sensors',
            allowedRoles: ['support_agent'],
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: { icon: 'manage_accounts', allowedRoles: ['support_agent'] },
    },
  ],
}

export default sidebarRoutes
